import { render, staticRenderFns } from "./quotations-waiting-confirmation.vue?vue&type=template&id=ee58f8b0&scoped=true&"
import script from "./quotations-waiting-confirmation.vue?vue&type=script&lang=js&"
export * from "./quotations-waiting-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./quotations-waiting-confirmation.vue?vue&type=style&index=0&id=ee58f8b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee58f8b0",
  null
  
)

export default component.exports